import SidebarItem from './SidebarItem';

export default SidebarItem;



// WEBPACK FOOTER //
// ./src/components/SidebarItem/index.js